import React from 'react';
import { NSConsignment } from '../Consignment.d';
import { FormikProps } from 'formik';

type TFormTabToolbar = FormikProps<NSConsignment.IFormTabToolbar> | null;
type TSummaryData = {
  revenue: number;
  totalConsignedItems: number;
};

const InitialSummaryData = {
  revenue: 0,
  totalConsignedItems: 0,
};

class ConsignmentRootDataClass {
  private _formTabToolbar: TFormTabToolbar = null;
  private _isFirstRenderTabToolbar: boolean = true;
  private _summaryData: TSummaryData = InitialSummaryData;
  private _isFetchingSummary: boolean = true;
  public _callback: () => void = () => {};

  get formTabToolbar() {
    return this._formTabToolbar;
  }

  get isFirstRenderTabToolbar() {
    return this._isFirstRenderTabToolbar;
  }

  get summaryData() {
    return this._summaryData;
  }

  get isFetchingSummary() {
    return this._isFetchingSummary;
  }

  setFormTabToolbar(param: TFormTabToolbar) {
    this._formTabToolbar = param;
  }

  setIsFirstRenderTabToolbar(param: boolean) {
    this._isFirstRenderTabToolbar = param;
  }

  setSummaryData(param: TSummaryData) {
    this._summaryData = param;
  }

  setIsFetchingSummary(param: boolean) {
    this._isFetchingSummary = param;
  }

  resetAllData() {
    this.setFormTabToolbar(null);
    this.setIsFirstRenderTabToolbar(true);
    this.setSummaryData(InitialSummaryData);
    this.setIsFetchingSummary(true);
  }

  dispatch(callback?) {
    if (callback) {
      callback();
    }

    this._callback();
  }
}

export const ConsignmentRootDataInstance = new ConsignmentRootDataClass();
export const ConsignmentRootDataContext = React.createContext<{
  value: ConsignmentRootDataClass;
}>({ value: ConsignmentRootDataInstance });
